import { gql } from "@apollo/client";

export const DESESTIMAR_CAPA = gql`
    mutation desestimarCapa($input: EditEstadoGestionCapaInput!){
        desestimarCapa(input: $input) {
            idGestionCapa
        }
    }
`;